import{getTag as o}from"../_internal/getTag.js";function e(t){return t!==null&&typeof t=="object"&&o(t)==="[object Arguments]"}export{e as isArguments};
